import { render, staticRenderFns } from "./ProjectFilter.vue?vue&type=template&id=444afcb4&"
import script from "./ProjectFilter.vue?vue&type=script&lang=js&"
export * from "./ProjectFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports